import React from 'react';

import type { SVGProps } from 'react';

const CaretRightIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10.5L4.35135 6L0 1.4L1.32432 0L7 6L1.32432 12L0 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretRightIcon;
